import { render, staticRenderFns } from "./summary-of-active-account-v3.vue?vue&type=template&id=15ab206e&scoped=true&"
import script from "./summary-of-active-account-v3.vue?vue&type=script&lang=js&"
export * from "./summary-of-active-account-v3.vue?vue&type=script&lang=js&"
import style0 from "./summary-of-active-account-v3.vue?vue&type=style&index=0&id=15ab206e&scoped=true&lang=css&"
import style1 from "./summary-of-active-account-v3.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ab206e",
  null
  
)

export default component.exports